import { SET_AVAILABLE_SERVICE_STATUS } from './types';
export var setAvailableServiceStatus = function setAvailableServiceStatus(serviceStatus) {
  return {
    type: SET_AVAILABLE_SERVICE_STATUS,
    payload: serviceStatus
  };
};